<h3 color="primary" class="popup-header">{{data?.title}}</h3>
<mat-dialog-content class="mat-typography">
  <custom-popup-message></custom-popup-message>
  <div fxLayout="column">
    <mat-form-field fxFill>
      <input matInput type="password" placeholder="Old Password" [(ngModel)]="dataModel.oldPassword" />
    </mat-form-field>
    <mat-form-field fxFill>
      <input matInput type="password" placeholder="New Password" [(ngModel)]="dataModel.password" />
    </mat-form-field>
    <mat-form-field fxFill>
      <input matInput type="password" placeholder="Retype Password" [(ngModel)]="retypePassword" />
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="primary" (click)="saveClick()">
    <i class="fas fa-check"></i> Save
  </button>
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Cancel
  </button>
</mat-dialog-actions>